/* assets/rate-chart-modal.js
   Learn More / Size Guide modal with zoom for size guide only.
*/

(function () {
  'use strict';

  function initRateChartModal() {
    const modal = document.getElementById('rc-content-modal');
    if (!modal) return;

    const closeButton = document.getElementById('rc-modal-close');
    const titleEl = document.getElementById('rc-modal-title');
    const imageEl = document.getElementById('rc-modal-image');
    const bodyEl = document.getElementById('rc-modal-body');

    if (!closeButton || !titleEl || !imageEl || !bodyEl) return;

    let sizeGuideZoomEnabled = false;

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
      imageEl.hidden = true;
      imageEl.removeAttribute('src');
      imageEl.classList.remove('rc-size-guide-zoomed');
      bodyEl.innerHTML = '';
      sizeGuideZoomEnabled = false;
    }

    function safeText(value) {
      return String(value || '').trim();
    }

    function safeUrl(value) {
      const url = String(value || '').trim();
      if (!url || url === 'null' || url === 'undefined') return '';
      return url;
    }

    function decodeRichText(node) {
      if (!node) return '';

      if (typeof node === 'string') {
        const raw = node.trim();
        if (!raw) return '';
        try {
          const parsed = JSON.parse(raw);
          return decodeRichText(parsed);
        } catch (e) {
          return raw;
        }
      }

      if (Array.isArray(node)) {
        return node.map(decodeRichText).join('');
      }

      if (typeof node === 'object') {
        if (node.type === 'text') return node.value || '';
        if (node.children) return decodeRichText(node.children);
        return '';
      }

      return '';
    }

    function decodeRichTextFromElement(el) {
      if (!el) return '';
      return decodeRichText(el.textContent.trim());
    }

    function renderLearnMore(button, source) {
      const itemTitle = safeText(button.dataset.title);
      const modalTitle = source.querySelector('.rc-modal-title')?.textContent.trim() || '';
      const modalSubtitle = source.querySelector('.rc-modal-subtitle')?.textContent.trim() || '';
      const descriptionText = decodeRichTextFromElement(source.querySelector('.rc-modal-description'));
      const galleryEl = source.querySelector('.rc-modal-gallery');
      const usageText = decodeRichTextFromElement(source.querySelector('.rc-usage-instructions'));
      const careText = decodeRichTextFromElement(source.querySelector('.rc-care-instructions'));
      const faqsText = decodeRichTextFromElement(source.querySelector('.rc-important-faqs'));
      const reviewText = decodeRichTextFromElement(source.querySelector('.rc-review-summary'));
      const primaryLabel = source.querySelector('.rc-primary-button-label')?.textContent.trim() || '';
      const primaryLink = safeUrl(source.querySelector('.rc-primary-link')?.textContent || '');
      const articleUrl = safeUrl(button.dataset.article);
      const videoUrl = safeUrl(button.dataset.video);
      const productUrl = safeUrl(button.dataset.product);

      titleEl.textContent = modalTitle || (itemTitle ? `Learn more: ${itemTitle}` : 'Learn more');

      const sections = [];

      if (modalSubtitle) sections.push(`<p><strong>${modalSubtitle}</strong></p>`);
      if (descriptionText) sections.push(`<p>${descriptionText}</p>`);

      if (galleryEl && galleryEl.children.length) {
        sections.push(`<div class="rc-modal-gallery-wrap">${galleryEl.innerHTML}</div>`);
      }

      if (usageText) sections.push(`<h4>Usage instructions</h4><p>${usageText}</p>`);
      if (careText) sections.push(`<h4>Care and return instructions</h4><p>${careText}</p>`);
      if (faqsText) sections.push(`<h4>Important FAQs</h4><p>${faqsText}</p>`);
      if (reviewText) sections.push(`<h4>Review summary</h4><p>${reviewText}</p>`);

      const links = [];
      if (articleUrl) links.push(`<a href="${articleUrl}" target="_blank" rel="noopener">Read article</a>`);
      if (videoUrl) links.push(`<a href="${videoUrl}" target="_blank" rel="noopener">Watch video</a>`);
     /* if (productUrl) links.push(`<a href="${productUrl}" target="_blank" rel="noopener">View product</a>`);*/

      if (links.length) sections.push(`<p>Choose an option to learn more:</p>${links.join(' ')}`);
      if (primaryLabel && primaryLink) sections.push(`<p><a href="${primaryLink}" target="_blank" rel="noopener"><strong>${primaryLabel}</strong></a></p>`);

      bodyEl.innerHTML = sections.length ? sections.join('') : 'Additional information is not available for this item.';
      imageEl.hidden = true;
      imageEl.removeAttribute('src');
      sizeGuideZoomEnabled = false;
    }

    function openSizeGuide(button) {
      const itemTitle = safeText(button.dataset.title);
      const imageUrl = safeUrl(button.dataset.image);

      titleEl.textContent = itemTitle || 'Size guide';
      bodyEl.innerHTML = '';

      if (imageUrl) {
        imageEl.src = imageUrl;
        imageEl.alt = itemTitle || 'Size guide';
        imageEl.hidden = false;
        imageEl.classList.remove('rc-size-guide-zoomed');
        sizeGuideZoomEnabled = true;
      } else {
        imageEl.hidden = true;
        imageEl.removeAttribute('src');
        bodyEl.textContent = 'Size guide is not available for this item.';
        sizeGuideZoomEnabled = false;
      }
    }

    function openModal(button) {
      const kind = button.dataset.kind || 'learn';
      const row = button.closest('.rate-chart__row');
      const source = row?.querySelector('.rc-modal-source');

      if (kind === 'size') {
        openSizeGuide(button);
      } else if (source) {
        renderLearnMore(button, source);
      } else {
        bodyEl.textContent = 'Additional information is not available for this item.';
        imageEl.hidden = true;
        imageEl.removeAttribute('src');
        sizeGuideZoomEnabled = false;
      }

      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    document.querySelectorAll('.rc-content-btn').forEach(button => {
      button.addEventListener('click', event => {
        event.preventDefault();
        openModal(button);
      });
    });

    // Zoom only for size guide image
    imageEl.addEventListener('click', () => {
      if (!sizeGuideZoomEnabled || imageEl.hidden) return;
      imageEl.classList.toggle('rc-size-guide-zoomed');
    });

    closeButton.addEventListener('click', closeModal);

    modal.addEventListener('click', event => {
      if (event.target === modal) closeModal();
    });

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRateChartModal, { once: true });
  } else {
    initRateChartModal();
  }
})();